
import {  Checkbox, Box, FormGroup, FormControlLabel,  Radio, RadioGroup } from "@mui/material";
const InterpolationExtrapolation = ({projectionData,modeType,onFieldChange}) => {
  return (  
        <Box sx={{ display: "flex", gap: 4 }}>
            <FormGroup className="disabled-checkbox-wrapper" sx={{ml: "5px"}}>
              <Box sx={{ alignItems :"center", }}>
                {/* <Checkbox
                  checked={projectionData?.is_interpolation }
                  onChange={(e) => onFieldChange("is_interpolation", e.target.checked)}
                  disabled={modeType === "view"}
                  disableRipple
                /> */}
                <span className="check-item-span">Interpolation</span>
                {/* {projectionData?.is_interpolation&& ( */}
                <RadioGroup
                  row
                  value={projectionData?.interpolation_option || "2"}
                  onChange={(e) => onFieldChange("interpolation_option", e.target.value)}
                  sx={{mt: '1px'}}
                >
                  <FormControlLabel value={1} control={<Radio disableRipple size="small"/>} label="Enable" disabled={modeType === "view"} />
                  <FormControlLabel value={2} control={<Radio disableRipple size="small"/>} label="Disable" disabled={modeType === "view"} />
                </RadioGroup>
              {/* )} */}
              </Box>
            </FormGroup>
            <FormGroup className="disabled-checkbox-wrapper" sx={{ ml: "370px" }}>
              <Box sx={{ justifyContent: 'center', alignItems: "center", }}>
                {/* <Checkbox
                  checked={projectionData?.is_extrapolation}
                  onChange={(e) => onFieldChange("is_extrapolation", e.target.checked)}
                  disabled={modeType === "view"}
                  disableRipple
                /> */}
                <span className="check-item-span">Extrapolation</span>
              </Box>
              {/* {projectionData?.is_extrapolation && ( */}
                <RadioGroup
                  row
                  value={projectionData?.extrapolation_option || "2"}
                  onChange={(e) => onFieldChange("extrapolation_option", e.target.value)}
                  sx={{mt: '1px' }}
                >
                  <FormControlLabel value={1} control={<Radio disableRipple size="small" />} label="Enable" disabled={modeType === "view"} />
                  <FormControlLabel value={2} control={<Radio disableRipple size="small"/>} label="Disable" disabled={modeType === "view"} />
                  <FormControlLabel value={3} control={<Radio disableRipple size="small"/>} label="Consider Boundary" disabled={modeType === "view"} />
                </RadioGroup>
              {/* )} */}
            </FormGroup>
        </Box>
  )
}

export default InterpolationExtrapolation